import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ExgInputComponent} from '../exg-input/exg-input.component';

@Component({
  selector: 'exg-switch',
  templateUrl: './exg-switch.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgSwitchComponent, multi: true
  }]
})
export class ExgSwitchComponent implements ControlValueAccessor {

  @Input() caption!: string;
  @Input() disabled!: string;
  // @Input()  value: any;
  @Output() valueChange = new EventEmitter();

  id = Math.random().toString(36).substring(2);

  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {
    this._value = obj;
    this.onChange(obj);
    this.onTouched(obj);
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  // ---------------


  change(newValue: any): void {
    this.valueChange.emit(newValue);
  }

}
